import ShareIcon from '../../../images-svg-sprite/ic_share.svg';

const className = '.product-description__social-share-icon';

const mainElement = document.querySelector(className);
if (!mainElement) {
    throw new Error('Please provide an element for Share Button');
}

const link = `<svg class="icon icon_ic_share" viewBox="${ShareIcon.viewBox}"><use xlink:href="#${
    ShareIcon.id
}"></use></svg>`;

const insertShareIcon = () => {
    mainElement.innerHTML = link;
};

const removeElement = () => {
    const addThisToolbox = document.querySelector('.addthis_toolbox');
    addThisToolbox.removeChild(mainElement);
};

export const init = () => {
    const script = document.createElement('script');
    script.src = 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5559f75935b65c75';
    script.async = 'async';
    script.onload = insertShareIcon;
    script.onerror = removeElement;
    document.body.appendChild(script);
};
